import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import { IMEI_INPUT_METHODS } from "../../../../pages/smartDeviceInsurancePages/newSmartDevicePolicy/data";
import FormTabs from "../../../common/tabs/formTabs";

const IMEIInputMethod = ({ selectedMethod, onMethodSelect }) => {
  const translate = useLanguageTranslate();

  const imeiMethodTabs = [
    {
      label_en: "Manually Enter IMEI",
      label_ar: "إدخال رقم IMEI يدويًا",
      type: IMEI_INPUT_METHODS.MANUAL,
    },
    {
      label_en: "From A Screenshot",
      label_ar: "لقطة من شاشة جهازك",
      type: IMEI_INPUT_METHODS.SCREENSHOT,
    },
  ];

  return (
    <div className="imei-input-method">
      <FormTabs
        label={translate(
          "How would you like to find your device's IMEI number?",
          "كيف تريد العثور على رقم IMEI لجهازك؟"
        )}
        tabs={imeiMethodTabs}
        activeTab={selectedMethod}
        onTabClick={(type) => onMethodSelect(type)}
        className="mb-6"
      />
    </div>
  );
};

export default IMEIInputMethod;
